module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ao-7ed590a16ff7642e7a85cc845a56f4b8.svg";